// Mirrors apps/backend/core/constants.py::AttentionConfig.CONSECUTIVE_MISSES —
// how many deliveries in a row a student must miss to "need attention"
// (PRD-58 §FR-5). The backend is canonical (magic-values.md §1); the SPA only
// uses it to NAME the window in copy ("sus últimas 2 tareas"), and switches
// to the count on the payload once the attention reason carries one.
export const ATTENTION_CONSECUTIVE_MISSES = 2

// Mirrors apps/backend/core/constants.py::AttentionConfig.WINDOW — how many
// of the latest grades the low-average check averages. Fallback only: the
// payload's `attention_n` names the window whenever it is present.
export const ATTENTION_AVERAGE_WINDOW = 5
